import { i18nextT } from "hooks/i18n/i18n";
import screenfull from "screenfull";

import { getVideoJsComponent } from "./utils";

import type { THEOPlayerRuntime } from "./theoplayerRuntime";
import type Player from "video.js/dist/types/player";

type TheaterModeButtonOptions = {
  isTheaterModeEnabled: boolean;
  toggleTheaterMode: () => void;
};

export const getTheaterModeButton = (runtime: THEOPlayerRuntime) => {
  const VideoJSButton = getVideoJsComponent("Button", runtime);

  class TheaterModeButton extends VideoJSButton {
    constructor(player: Player, options = {}) {
      super(player, options);

      document.addEventListener(
        "fullscreenchange",
        this.handleChangeForScreenfull
      );

      if (screenfull.isEnabled) {
        screenfull.on("change", this.handleChangeForScreenfull);
      }

      player.on("dispose", () => {
        document.removeEventListener(
          "fullscreenchange",
          this.handleChangeForScreenfull
        );

        if (screenfull.isEnabled) {
          screenfull.off("change", this.handleChangeForScreenfull);
        }
      });
    }

    handleChangeForScreenfull = () => {
      if (
        this.player().isFullscreen() ||
        (screenfull.isEnabled && screenfull.isFullscreen)
      ) {
        this.hide();
      } else {
        this.show();
      }
    };

    handleClick() {
      const options = this.options(undefined) as TheaterModeButtonOptions;
      options.toggleTheaterMode();
    }

    createEl() {
      const theaterIcon = `
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="6.5" y="10.5" width="23" height="15" stroke="white" stroke-width="3"/>
      </svg>
    `;

      const label = i18nextT("streaming.controller.theaterMode");
      // ツールチップは自前で出す (vjs-custom-button-tooltip) ので、ブラウザ標準の title は付けない
      const el = super.createEl("button", {
        className:
          "vjs-custom-theater-mode-button vjs-custom-button vjs-control vjs-button",
        innerHTML: `
      ${theaterIcon}
        <span class="vjs-control-text">${label}</span>
        <span class="vjs-custom-button-tooltip" aria-hidden="true">${label}</span>
      `,
      });
      return el;
    }
  }

  return TheaterModeButton;
};
